// Turns a stored profile image (URL/path, base64 string or MongoDB Buffer)
// into an <img> src, falling back to a default avatar.
export const displayImage = (img) => {
  // 1. Handle Null/Empty
  if (!img) {
    return "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
  }

  // 2. Handle File Paths or full URLs (e.g., "profile-pictures/123.png")
  // If it doesn't look like a Base64 string and is a string, it's a path.
  if (
    typeof img === "string" &&
    !img.startsWith("UklGR") &&
    !img.startsWith("data:")
  ) {
    // If you use a storage bucket, prefix it: return `https://your-s3-bucket.com/${img}`;
    return img;
  }

  // 3. Handle Raw Base64 Strings (like User 1 in your array)
  // WebP images often start with 'UklGR'
  if (
    typeof img === "string" &&
    (img.startsWith("UklGR") || img.length > 100)
  ) {
    return `data:image/webp;base64,${img}`;
  }

  // 4. Handle MongoDB Buffer Objects { data: [...], type: 'Buffer' }
  try {
    const bufferSource = img.data ? img.data : img;
    const uint8 = new Uint8Array(bufferSource);

    let binary = "";
    for (let i = 0; i < uint8.length; i++) {
      binary += String.fromCharCode(uint8[i]);
    }

    return `data:image/webp;base64,${btoa(binary)}`;
  } catch (e) {
    return "https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y";
  }
};
